<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :pageId="this.$options.name"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              @select-changed="onChangeBizCodes"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="condType"
              :selected="selectedValues.COD_USER_GRP_SRCH_COND"
              codeId="COD_USER_GRP_SRCH_COND"
              :initialSelectedIndex="0"
              :defaultOption="'all'"
              @loaded="onCondTypeLoaded"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="condContent"
              default
              value
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00014'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns"
        :columnsautoresize="true"
        :columnsresize="true"
        :initial-pagesize="10"
        width="100%"
        :dataset="'dsData'"
        :initialPagesize="10"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickSelect"
        >
          {{ $t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMA_00014', // eslint-disable-line vue/name-property-casing
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      selectedValues: {
        COD_USER_GRP_SRCH_COND: { key: '', label: '' },
      },
      selectedBizCode: [],
      condContent: '',
      localdata: [],
      gridColumns: [
        {
          text: this.$t('MSG_TXT_USER_GRP_ID'),
          datafield: 'userGroupId',
          width: 150,
        },
        {
          text: this.$t('MSG_TXT_USER_GRP_NAME'),
          datafield: 'userGroupName',
        },
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
        },
      ],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata',
    datafields: [
      //      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'bsicAuthYn', type: 'string', map: 'bsicAuthYn' },
      { name: 'userGroupContent', type: 'string', map: 'userGroupContent' },
      { name: 'userGroupConditionFormalValue', type: 'string', map: 'userGroupConditionFormalValue' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'userName', type: 'string', map: 'userName' },
      { name: 'userGlobalName', type: 'string', map: 'userGlobalName' },
      { name: 'knoxId', type: 'string', map: 'knoxId' },
      { name: 'deptName', type: 'string', map: 'deptName' },
      { name: 'deptGlobalName', type: 'string', map: 'deptGlobalName' },
      { name: 'dsplLangId', type: 'string', map: 'dsplLangId' },
      { name: 'portalId', type: 'string', map: 'portalId' },
    ],
  }],
  mounted() {
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onReset() {
      this.$refs.condType.reset();
      this.$refs.taskIdSelect.reset();
      // this.selectedValues.COD_USER_GRP_SRCH_COND.key = this.condTypeKey;
      this.condContent = '';
    },
    onSearch() {
      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }
      const condTypeCode = this.selectedValues.COD_USER_GRP_SRCH_COND.key;
      const queryParams = {
        taskId: taskId || '',
        searchCond: condTypeCode || '',
        searchWord: this.condContent || '',
      };

      http.request(this.$options.name, 'DTS_CMA_00008', {
        query: queryParams,
      }).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.dsData.setRawData(res.data);
          } else {
            this.dsData.setRawData([]);
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onKeyUpInput() {
      const searchFieldNewText = this.condContent;
      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.condContent = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onCondTypeLoaded(optionsList) {
      this.condTypeKey = optionsList[0].key;
    },
    /**
     *  닫기
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    /**
     *  선택
     */
    onClickSelect() {
      const selectedData = this.dsData.getSelectedRawData();
      if (selectedData.length !== 0) {
        this.closePagePopup(selectedData);
      } else {
        // 선택 안했을 때
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));// 선택 된 항목이 없습니다.
      }
    },
  },
};
</script>
<style scoped>
</style>
